import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
const pinia = createPinia();

import "./auth";

import ElementPlus from "element-plus";
import "@/styles/element-variables.scss";

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import "animate.css";

/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";
/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
/* import specific icons */
import {
  faFileLines,
  faCircleQuestion,
  faCirclePlus,
  faCircleMinus,
  faAngleLeft,
  faAngleRight,
  faAngleDown,
  faAngleUp,
  faCompactDisc,
  faFilePdf,
  faFolderClosed,
  faCircleXmark,
  faHeadphones,
  faCircleInfo,
  faLocationCrosshairs,
  faCirclePlay,
  faCirclePause,
} from "@fortawesome/free-solid-svg-icons";
/* add icons to the library */
library.add(
  faFileLines,
  faCircleQuestion,
  faCirclePlus,
  faCircleMinus,
  faAngleLeft,
  faAngleRight,
  faAngleDown,
  faAngleUp,
  faCompactDisc,
  faFilePdf,
  faFolderClosed,
  faCircleXmark,
  faHeadphones,
  faCircleInfo,
  faLocationCrosshairs,
  faCirclePlay,
  faCirclePause
);

import axios from "axios";
import VueAxios from "vue-axios";

const app = createApp(App);

app.component("font-awesome-icon", FontAwesomeIcon);

app.use(ElementPlus);
app.use(VueAxios, axios);
app.use(router).use(pinia).mount("#app");
